import ReactHtmlParser from 'react-html-parser';
import { sanitize } from 'dompurify';

const CommonDecimalPattern = /^(\d*(\.\d*)?)$/;
const NegativeDecimalPattern = /^(\-?\d*(\.\d*)?)$/;
const StationFormatPattern = /^(\+|\d*\+\d{0,2}(\.\d*)?)$/

/**
 * Test a station string with allowance of partial inputs.
 * @param value String value to match in the format of a station.
 * @returns True if a match was found, False if no match was found.
 */
export function testStationString(value: string): boolean {
  return (StationFormatPattern.test(value) || testDecimalString(value, false, true));
}

/**
 * Tests that a string is a decimal number without letters, +, or other symbols. Empty string and - are allowed.
 * @param value String to test.
 * @param negativeAllowed makes - n valid character
 * @param station set to true if testing a station string to include + as a valid character
 * @returns True if the string is a decimal number, False, if there are invalid charracters included.
 */
export function testDecimalString(value: string, negativeAllowed?: boolean, station?: boolean): boolean {
  // Test if any character not 0-9, ., or - is in the string.
  const letterPattern = station ? /[a-zA-Z]/ : /[a-zA-Z+]/;
  const letterTest = letterPattern.test(value);
  if (letterTest) return false;
  if (negativeAllowed) {
    return NegativeDecimalPattern.test(value);
  }
  else {
    return CommonDecimalPattern.test(value);
  }
}

// turns string into Title Case
export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const getAlphabetArrayUpperCase = () => {
  return [...Array(26)].map((_, i) => String.fromCharCode(65 + i));
}
// this hotspot
export const isValidUrl = urlString => {
  try {
    const parsedUrl = new URL(urlString);
    return !!parsedUrl;
  }
  catch (error) {
    // Invalid url strings passed to URL throw an error.
    return false;
  }
}

// parsing HTML string 
export const htmlParser = (htmlString: string) => {
  return ReactHtmlParser(sanitize(htmlString))
}

// Assuming separated by space
export const capAndUnderscore = (str: string) => {
  return str.replace(/\s/g, () => '_').toUpperCase();
}
export const updateNameNoSpace = (str: string) => {
  //Transform a string in format "First Last" to "FirstLast"
  return str.replace(/[\s_]+/g, '');
}
export const updateNameAddSpace = (str: string) => {
  //Transform a string in format "FirstLast" to "First Last"
  return str.replace(/([a-z])([A-Z])/g, '$1 $2');
}
//replace underscore with space
export const splitUnderscores = (str) => {
  if (!str) {
    return ''
  }
  return str.replace(/_/g, () => ' ');
}

/**
 * Transform a string in format "FIRST_LAST" to "First Last"
 * @param str 
 * @returns 
 */
export const toTitleFromUnderscore = (str) => {
  return toTitleCase(splitUnderscores(str));
}

/**
 * Turn a string from space separated to hyphen-separated and all lowercase.
 * Usual className/id string format
 * @param str String to Transform.
 * @returns string-now-transformed
 */
export const toHyphenedLowerCase = (str) => {
  return str.replace(/\s/g, () => '-').toLowerCase();
}

/**
 * 
 * @param val string value to change from "FirstLast" to "First Last"
 * @returns string with capitalized words separated by single space
 */
export const valueToName = (val: string) => {
  return val.replace(/[A-Z][a-z]*/g, function (word) {
    return word + ' ';
  }).trim();
}

export const emailToName = (string) => {
  if (string) {
    return toTitleCase(string.split('@')[0].replace('.', ' '));
  } else {
    return string;
  }
};
export const updateNameAndValueOptions = (options) => {
  options.forEach(option => {
    option.name = updateNameNoSpace(option.name)
    option.value = capAndUnderscore(option.value);
  });
  return options;
}
export const isValidBase64ImageRegex = (string) => {
  const base64ImageRegex = /^data:image\/(jpeg|png|gif|bmp|webp);base64,([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
  return base64ImageRegex.test(string);
}